module.exports = __webpack_public_path__ + "img/DEBI-Ultra.901b9307.png";